// extracted by mini-css-extract-plugin
module.exports = {"mobileIssueList":"Subscription__mobileIssueList--3bmjL"};